import { z } from 'zod';

import { currencyCodeSchema, dateTimeSchema } from '@apple/utils/globalization/models';

import { sortedImageSchema } from '../../product/models/image';
import { productKeySchema } from '../../product/models/product';

/** @see AppleRetail.Web.Features.Orders.RecentOrdersController.RecentlyOrderedProduct **/
export type RecentlyOrderedProduct = z.infer<typeof recentlyOrderedProductSchema>;

/** @see AppleRetail.Web.Features.Orders.RecentOrdersController.RecentlyOrderedProduct **/
export const recentlyOrderedProductSchema = z.object({
	itemId: productKeySchema,
	sku: z.string(),
	title: z.string(),
	orderDate: dateTimeSchema,
	poNumber: z.string(),
	quantity: z.number(),
	images: z.array(sortedImageSchema),
	lineStatus: z.string(),
	price: z.number(),
	unitOfMeasure: z.string(),
	currencyCode: currencyCodeSchema,
	storeCode: z.string(),
});

export const pendingReplyCountSchema = z.number().int().nonnegative();
